import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LaneSheetMeetEventsStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
};

const LaneSheetMeetEventsContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LaneSheetMeetEventsStateContext.Provider value={stateHook}>
      {children}
    </LaneSheetMeetEventsStateContext.Provider>
  );
};

export default LaneSheetMeetEventsContextProvider;